swiperRelatedProducts = {
    init: function () {
        if ($(".swiper--related-products").length > 0) {
            var swiper = new Swiper(".swiper--related-products", {
                slidesPerView: "auto",
            });

        }
    }
};

$(document).ready(function () {
    swiperRelatedProducts.init();
});